

import { ErrorOutline, KeyboardArrowDown } from "@mui/icons-material";
import { Alert, Button, CircularProgress, Dialog, InputBase, MenuItem, Select } from "@mui/material";
import axios from "axios";
import React, { createElement, useState } from "react";
import { useNavigate } from "react-router-dom";

const FlowModal = ({ open, setOpen, page }) => {
    const navigate = useNavigate()
    const [loader, setLoader] = useState(false)
    const [errorMsg, setErrorMsg] = useState(null)
    const [successMsg, setSuccessMsg] = useState(null)

    const [user, setUser] = useState({
        organization_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        userId: JSON.parse(localStorage.getItem('user'))?.userId?.S || null,
        email: JSON.parse(localStorage.getItem('user'))?.email?.S || null,
        password: JSON.parse(localStorage.getItem('user'))?.password?.S || null,
        first_name: JSON.parse(localStorage.getItem('user'))?.fName?.S || null,
        last_name: JSON.parse(localStorage.getItem('user'))?.lName?.S || null,
        company_name: JSON.parse(localStorage.getItem('organization'))?.organization_name?.S || '',
        agreed: false,
        registeredFromGoogle: JSON.parse(localStorage.getItem('user'))?.registeredFromGoogle?.BOOL || false
    });

    const addOrganization = async () => {
        setErrorMsg(null)
        if (user.company_name.length >= 1) {
            setLoader(true)
            //console.log(JSON.parse(localStorage.getItem('user'))?.userId?.S)
            await axios
                .post(process.env.REACT_APP_BACKEND_URL + "user/add-created-user-to-org", {
                    ...user,
                    userId: JSON.parse(localStorage.getItem('user'))?.userId?.S
                })
                .then((res) => {
                    console.log(res)
                    if (res.data.status ===  "success") {
                        localStorage.setItem("user", JSON.stringify(res.data.user)); //store user data in local storage
                        localStorage.setItem(
                            "organization",
                            JSON.stringify(res.data.organization)
                        ); //stores organization datat in local storage
                        setSuccessMsg('Organization has been created, we would now redirect you to complete onboarding flow. ')
                        setTimeout(() => {
                            navigate('/register');
                            setLoader(false);
                        }, 4000);
                    } else {
                        setErrorMsg(`${res.data.msg}`);
                        setLoader(false);
                    }
                })
                .catch((err) => {
                    setLoader(false);
                });
        } else {
            setErrorMsg('Please enter company name for your organization')
        }
    }


    const deleteUser = async () => {
        setErrorMsg(null)
        if (window.confirm('Are you sure you want to delete this account ?')) {
            setLoader(true)
            let deletedUser = axios
                .post(process.env.REACT_APP_BACKEND_URL + "delete-user-by-id", user)

            console.log(deletedUser)
            setSuccessMsg('User deleted successfully')
            setTimeout(() => {
                navigate('/login')
                setLoader(true)
            }, 2000);
        }
    }
    return (
        <Dialog open={open} fullWidth={true} maxWidth={"sm"}


            BackdropProps={{
                style: { backgroundColor: "rgba(0, 0, 0, 0.2)" }, // Adjust opacity here
            }}
        >
            <div className="lg:px-8 px-4 py-14">

                <div className="lg:text-[20px] text-[#030229]  text-[15px] font-semibold  text-center mb-4">
                    <div className="text-center">No Organization</div>
                    {errorMsg && (
                        <div className="text-center text-red-500 lg:text-[13px] text-[12px]   font-semibold ">
                            <ErrorOutline sx={{ fontSize: "" }} /> {errorMsg}
                        </div>
                    )}

                    {successMsg && (
                        <Alert color={'success'} sx={{ my: 2 }}  >
                            <div className="text-[14px]">{successMsg}</div>
                        </Alert>
                    )}
                </div>


                <div className="lg:text-[14px] text-[13px] text-center px-2">
                    This account is not linked to an organization. Please provide your company name to proceed.
                </div>

                <div className="space-y-2 mb-3 mt-3">
                    <div className=" lg:text-[14px] text-[13px] ">Company name</div>
                    <InputBase
                        value={user.company_name}
                        onChange={(e) => {
                            setUser({ ...user, company_name: e.target.value })
                        }}
                        sx={{
                            bgcolor: "#F7F7F8",
                            width: "100%",
                            px: 2,
                            py: "2px",
                            fontSize: "14px",
                        }}
                    />
                </div>

                <div className="flex items-center justify-center space-x-3 mt-4">
                    <Button
                        sx={{
                            textTransform: "none",
                            bgcolor: 'rgba(96,91,255,0.1)',
                            color: "#605BFF",
                            py: "6px",
                            px: "30px",
                            borderRadius: "7px",
                            border: '1px solid rgba(96,91,255,0.1)',
                            fontSize: { lg: "14px", xs: "13px" },
                            width: "fit",
                        }}
                        onClick={() => {
                            addOrganization()
                        }}
                        disabled={loader}
                    >

                        {loader ? (
                            <div className="flex justify-center">
                                <CircularProgress size={"1.0rem"} sx={{ color: "#FFF", animationDuration: "0.7s", }} />
                            </div>
                        ) : (
                            'Create Organization'
                        )}

                    </Button>



                </div>


                <div className="flex items-center justify-between  mt-2">
                    <Button
                        sx={{
                            textTransform: "none",
                            bgcolor: 'blue',
                            color: "white",
                            py: "6px",
                            px: "7px",
                            borderRadius: "7px",
                            fontSize: { lg: "14px", xs: "13px" },
                            width: "fit",
                        }}
                        onClick={() => {

                            let a = document.createElement('a')
                            a.href = 'mailto:hello@twilanswer.com';
                            a.click();
                        }}

                    >
                        Contact Support
                    </Button>


                    <Button
                        sx={{
                            textTransform: "none",
                            bgcolor: 'red',
                            color: "white",
                            py: "6px",
                            px: "7px",
                            borderRadius: "7px",
                            fontSize: { lg: "14px", xs: "13px" },
                            width: "fit",
                        }}
                        disabled={loader}
                        onClick={() => {
                            deleteUser()
                        }}
                    >

                        {loader ? (
                            <div className="flex justify-center">
                                <CircularProgress size={"1.0rem"} sx={{ color: "#FFF", animationDuration: "0.7s", }} />
                            </div>
                        ) : (
                            'Delete Account'
                        )}
                    </Button>
                </div>



            </div>
        </Dialog>
    );
};

export default FlowModal;
